module.exports = __webpack_public_path__ + "89854948047f7d6832a2dfcd14948e06.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/afro-hair-s.png
// module id = 2148
// module chunks = 0